import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { get } from "../../../../utils/api";
import MultiColumns from "../MultiColumns";

import { companyId } from "../../../../utils/companyId";

const HumanRights = ({ isEditing }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/social/human_rights/${companyId}`);
        // Update state only if data is available
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const questionary = [
    { mainheading: "Human Rights Assessments", gridSize: { xs: 12 } },
    {
      key: "humanRightsAssessments.numberOfAssessmentsDone",
      question: "Number of assessment done",
    },

    {
      key: "humanRightsAssessments.percentageOfOperationsAssessed.value",
      key2: "humanRightsAssessments.percentageOfOperationsAssessed.unit",
      question: "% of operations assessed",
    },
    {
      mainheading: "Policies and Procedures on Human Rights",
      gridSize: { xs: 12 },
    },
    {
      key: "policiesAndProcedures",
      subkey: "existence",
      question: "Existence",
    },
    {
      key: "policiesAndProcedures",
      subkey: "implementation",
      question: "Implementation",
    },
    {
      mainheading: "Incidents of Human Rights Violations",
      gridSize: { xs: 12 },
    },

    {
      key: "incidentsOfHumanRightsViolations.totalIncidentsRaised",
      question: "Total Number of Incidents Raised",
    },
    {
      key: "incidentsOfHumanRightsViolations.percentageOfResolution.value",
      key2: "incidentsOfHumanRightsViolations.percentageOfResolution.unit",
      question: "Percentage of Resolution",
    },
  ];

  return (
    <MultiColumns
      title="HUMAN RIGHTS"
      url={`/social/human-right`}
      questionary={questionary}
      columns={2}
      data={data}
      isEditing={isEditing}
    />
  );
};

export default HumanRights;
